import React from 'react';
import { Page } from '../Common/Components/Page';
import { PickingSidesContent } from './Components/PickingSidesContent';

export const PickingSides = (): React.JSX.Element => (
  <Page title="Picking: Sides" accessKey={'pickingSides'} isSearchable={true}>
    <PickingSidesContent />
  </Page>
);
